import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productFilter'
})
export class ProductFilterPipe implements PipeTransform {

  transform(products: any, filterString: any) {
    if (!products || products.length === 0) {
      return products;
    }

    return products.filter((product: any) => {

      // Filter by search query
      const keywordsFilter = (filterString[0].toLowerCase()).split(' ')
      const keywordsFilterResult = keywordsFilter.every(keyword => ((product.product_name).toLowerCase()).indexOf(keyword) >= 0);

      // Filter by country
      const countryFilter = filterString[1]
      const countryFilterResult = (countryFilter === '' || product['country_code'] === countryFilter);

      // Filter by status
      const statusFilter = filterString[2]
      const statusFilterResult = (statusFilter === '' || product['display_status'] === statusFilter);

      return (keywordsFilterResult && countryFilterResult && statusFilterResult)
    })

  }

}
